var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40C31.0455 40 39.9998 31.0457 39.9998 20C39.9998 8.95428 31.0455 -3.05176e-05 19.9998 -3.05176e-05C8.95412 -3.05176e-05 -0.000183105 8.95428 -0.000183105 20C-0.000183105 31.0457 8.95412 40 19.9998 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.10352e-05 20C-6.10352e-05 27.5809 4.21791 34.1762 10.4347 37.5682V2.43182C4.21791 5.82385 -6.10352e-05 12.4192 -6.10352e-05 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.756 26.9565C39.5599 24.7899 39.9999 22.4464 39.9999 20C39.9999 17.5536 39.5599 15.2101 38.756 13.0435H1.244C0.440017 15.2101 -6.10352e-05 17.5536 -6.10352e-05 20C-6.10352e-05 22.4464 0.440017 24.7899 1.244 26.9565L19.9999 28.6957L38.756 26.9565Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C28.5993 40 35.9301 34.5725 38.7561 26.9565H1.24402C4.0698 34.5725 11.4007 40 20 40V40Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 29.2405 6.26727 37.016 14.7826 39.311V0.688965C6.26727 2.98396 0 10.7594 0 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2357 8.80109L10.3911 6.95648L9.16143 8.18633L7.93174 6.95648L6.08713 8.80109L7.3169 10.0309L6.08698 11.2607L7.93158 13.1053L9.16135 11.8755L10.3911 13.1053L12.2357 11.2607L11.006 10.0309L12.2357 8.80109Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOman);
export default __webpack_public_path__ + "static/media/oman.7d4be79c66355740eca6752f75eb0036.svg";
export { ForwardRef as ReactComponent };